import $ from 'jquery';
import debounce from './utils/debounce';

class HeaderSearch {
    constructor() {
        this.$body = $('body');
        this.$button = $('.js-header-search--button');
        this.$mobileButton = $('.js-header-search--mobile-button');
        this.$form = $('.js-header-search--form');
        this.$formInput = $('.js-header-search--text-input');
        this.$closeButton = $('.js-header-search--close');
        this.$header = $('.js-header');
        this.$window = $(window);

        this.$button.on('click', $.proxy(this.buttonClick, this));
        this.$closeButton.on('click', $.proxy(this.closeForm, this));
        this.$mobileButton.on('click', $.proxy(this.mobileButtonClick, this));
        this.watchForEsc();

        this.$window.on('resize', debounce(() => {
            this.resetSearch();
        }, 300));

        this.$window.on('mobile-menu-open', () => {
            this.resetSearch();
        });
    }

    buttonClick(e) {
        const $elem = $(e.currentTarget);

        if (this.$form.hasClass('is-open')) {
            return true;
        } else {
            e.preventDefault();
        }

        this.$form.addClass('is-open').find('.js-header-search--text-input').attr('tabindex', 0).focus();
        $elem.addClass('is-clicked');
    }

    closeForm(e) {
        this.$form.removeClass('is-open');
        this.$formInput.attr('tabindex', -1);
        this.$button.focus();
        this.$button.removeClass('is-clicked');
    }

    mobileButtonClick() {
        this.$mobileButton.toggleClass('is-open');
        this.$form.toggleClass('is-open');
        this.$header.toggleClass('has-search-open');

        if (this.$mobileButton.hasClass('is-open')) {
            this.$window.trigger('search-mobile-open');
        }
    }

    watchForEsc() {
        $(document).keyup((e) => {
            const key = e.keyCode || e.which;

            if (key === 27) {
                if (this.$form.hasClass('is-open')) {
                    this.$closeButton.trigger('click').focus();
                }
            }
        });
    }

    resetSearch() {
        this.$form.removeClass('is-open');
        this.$mobileButton.removeClass('is-open');
        this.$button.removeClass('is-clicked');
        this.$header.removeClass('has-search-open');
    }
}

export default HeaderSearch;
